// @ts-nocheck

import { ChainId } from '@uniswap/sdk'
import React, { useState, useRef, useEffect, useCallback } from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { Text } from 'rebass'

import styled from 'styled-components'
import mobileLogo from '../../assets/images/mobile-logo.png'

// import Logo from '../../assets/svg/logo.svg'
import Logo from '../../assets/images/logo.svg'
import Tok from '../../assets/images/tok.png'
import LogoDark from '../../assets/svg/logo_white.svg'
import Wordmark from '../../assets/svg/wordmark.svg'
import WordmarkDark from '../../assets/svg/wordmark_white.svg'
import { useActiveWeb3React } from '../../hooks'
import { useDarkModeManager } from '../../state/user/hooks'
import { useETHBalances } from '../../state/wallet/hooks'
import Modal from '../Modal'
import menuIcon from '../../assets/images/menu.png'
import closeMenu from '../../assets/images/closeMenu.png'
import Tips from '../Tips'
import fold from '../../assets/images/fold.svg'

import { YellowCard } from '../Card'
import Settings from '../Settings'
// import Menu from '../Menu'

import Row, { RowBetween } from '../Row'
import Web3Status from '../Web3Status'
// import VersionSwitch from './VersionSwitch'

const HeaderFrame = styled.div`
  /* display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column; */
  max-width: 1300px;
  margin: auto;
  top: 0;
  /* position: sticky; */
  z-index: 2;
  padding: 0 10px;
  /* background:red; */
  background: #0f2143;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 12px 0 5 0;
    width: calc(100%);
    top:36px;
  `};

  @media (max-width: 768px) {
    padding: 0 18px;
  }
`

const HeaderElement = styled.div`
  max-width: 1120px;
  height: 44px;
  display: flex;
  align-items: center;
`

const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    // margin-top: 0.5rem;
`};
`

const Title = styled.div`
  display: flex;
  align-items: center;
  pointer-events: auto;

  :hover {
    cursor: pointer;
  }
`

const TitleText = styled(Row)`
  width: fit-content;
  white-space: nowrap;
  /* ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `}; */
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)}; */
  /* border-radius: 12px; */
  /* white-space: nowrap; */
  width: 100%;
  /* color: #fff; */

  :focus {
    border: 1px solid blue;
  }
`

const TestnetWrapper = styled.div`
  white-space: nowrap;
  width: fit-content;
  margin-left: 10px;
  pointer-events: auto;
`

const NetworkCard = styled(YellowCard)`
  width: fit-content;
  margin-right: 10px;
  border-radius: 12px;
  padding: 8px 12px;
`

const UniIcon = styled.div`
  display: flex;
  vertical-align: middle;
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    img { 
      vertical-align: middle;
    }
  `};
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  /* ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    align-items: flex-end;
  `}; */
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`
const MenuModal = styled.div`
  background-color: ${({ theme }) => theme.bg1};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 3rem;
  left: 20%;
  z-index: 100;
  padding: 23px 10px;
  width: 127px;
  a {
    font-weight: 900;
    font-size: 16px;
    color: #191b1f;
    cursor: pointer;
    margin-bottom: 30px;
    text-decoration: none;
    &:hover {
      color: #3561ca;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .active {
    color: #3561ca;
  }
`

const NETWORK_LABELS: { [chainId in ChainId]: string | null } = {
  [ChainId.MAINNET]: null,
  [ChainId.RINKEBY]: 'Rinkeby',
  [ChainId.ROPSTEN]: 'Ropsten',
  [ChainId.GÖRLI]: 'Görli',
  [ChainId.TOKLOCAL]: 'TokLocal',
  [ChainId.TOKTESTNET]: 'Tok',
  [ChainId.TOKNET]: 'Tok',
  [ChainId.SEPOLIA]: 'Sepolia',
  [ChainId.DORNET]:"Dor"
}
const Router = styled.div`
  display: flex;
  align-items: center;
  gap: 70px;
  a {
    font-size: 20px;
    color: #fff;
    opacity: 0.6;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    &:hover {
      /* color: #3561ca; */
      opacity: 0.9;
    }
    &:hover::before {
      /* color: #3561ca; */
      /* opacity: 0.9; */
      width: 100%;
    }
    &::before {
      position: absolute;
      content: '';
      /* width: 100%; */
      width: 0;
      height: 2px;
      background: #fff;
      left: 0;
      bottom: -9px;
      transition-duration: 0.3s;
      transform-origin: left;
    }
  }

  .active {
    color: #fff;
    opacity: 0.9;
    &::before {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    display: none;
    margin-top: 2px;
    margin-left: 0px;
    a {
      font-size: 20px;
      margin-right: 10px;
    }
  }
`
const Dropdown = styled.div`
  position: relative;
  display: inline-block; /* Ensures hover area is consistent */

  /* Hover on the entire container to show the menu */
  &:hover > .dropdown-menu {
    display: block;
    opacity: 1;
    visibility: visible;
  }

  & > span.dropdown-label {
    color: rgba(255, 255, 255, 0.6);
    font-size: 1.25rem;
    font-weight: 600;
    cursor: pointer;
    padding: 0.25rem 0.5rem; /* Adds hoverable area */
    /* &:hover {
      color: rgba(255, 255, 255, 0.9);
    } */
    @media (max-width: 640px) {
      font-size: 1rem;
      padding: 0.2rem 0.4rem;
    }
  }

  & > div.dropdown-menu {
    position: absolute;
    top: 35px;
    left: 0;
    display: block; /* Always rendered, controlled by opacity/visibility */
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
    z-index: 10;

    @media (max-width: 640px) {
      top: 1.5rem;
      left: -0.5rem;
      width: 100%;
    }

    & > div.menu-content {
      width: 16rem;
      padding: 1.5rem 0.5rem;
      background-color: white;
      border-radius: 0.25rem;
      box-shadow: 0px 4px 10px rgba(29, 33, 41, 0.1);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 1.5rem;
      overflow: hidden;

      @media (max-width: 640px) {
        width: calc(100vw - 2rem);
        padding: 1rem 0.25rem;
      }

      & > div.menu-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 0.5rem;

        & > div.staking-toggle {
          width: 100%;
          padding: 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          cursor: pointer;

          &:hover {
            background-color: #f3f4f6;
          }

          @media (max-width: 640px) {
            padding: 0.75rem;
          }

          & > div.staking-text {
            flex: 1;
            color: #1f2937;
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.5;
          }

          & > div.icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1; /* Ensures vertical alignment */

            & > img {
              width: 1.25rem;
              height: 1.25rem;
              transition: transform 200ms;
              transform: ${props => (props.isStakingOpen ? 'rotate(0deg)' : 'rotate(180deg)')};

              @media (max-width: 640px) {
                width: 1rem;
                height: 1rem;
              }
            }
          }
        }

        & > div.sub-menu {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 0.5rem;
          transition: all 200ms ease-in-out;

          & > a.sub-menu-item {
            width: 100%;
            padding: 1rem;
            padding-left: 2rem;
            color: #1f2937;
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.5;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1rem;
            text-decoration: none;

            &:hover {
              background-color: #f3f4f6;
            }

            @media (max-width: 640px) {
              padding: 0.75rem;
              padding-left: 1.5rem;
              font-size: 0.875rem;
            }
          }
        }
      }
    }
  }
`

export default function Header() {
  const { account, chainId } = useActiveWeb3React()
  const { pathname } = useLocation()

  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const [isDark] = useDarkModeManager()

  const [show, setShow] = useState(false)

  const menuRef = useRef<HTMLDivElement>()

  const history = useHistory()


  const handleClickOutside = event => {
    event.stopPropagation()
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      // console.log(event)

      setShow(false)
    } else {
    }
  }
  function jumpSwap() {
    if (pathname === '/swap' || pathname === '/pool' || pathname === '/add/ETH') {
      return
    }
    history.push('/swap')
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      setShow(false)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  return (
    <HeaderFrame>
      <RowBetween>
        <HeaderElement>
          <Title onClick={jumpSwap}>
            {/* <UniIcon>
              <img src={Logo} width={'23px'} alt="logo" />
            </UniIcon> */}
            <TitleText>
              {isMobile ? (
                <img style={{ width: '100px' }} src={Tok} alt="logo" />
              ) : (
                <img style={{ width: '128px' }} src={Tok} alt="logo" />
              )}
            </TitleText>
          </Title>
          {/* {isMobile && (
            <div ref={menuRef} onClick={() => setShow(show ? false : true)}>
              {show ? <img src={closeMenu} width={19} /> : <img src={menuIcon} width={21} />}

              {show && (
                <MenuModal>
                  <NavLink to={'/swap'} className={pathname === '/swap' || pathname === '/pool' ? 'active' : ''}>
                    Swap
                  </NavLink>
                  <NavLink to={'/explore'} className={pathname === '/explore' ? 'active' : ''}>
                    Explore
                  </NavLink>
                  <a href="https://bridge.tokchain.org" target="_blank">
                    Bridge
                  </a>
                </MenuModal>
              )}
            </div>
          )} */}
        </HeaderElement>
        <Router>
          <NavLink to={'/swap'} className={pathname === '/swap' ? 'active' : ''}>
            Swap
          </NavLink>
          <NavLink to={'/pool'} className={pathname === '/pool' ? 'active' : ''}>
            Liquidity
          </NavLink>
          <NavLink to={'/explore'} className={pathname === '/explore' ? 'active' : ''}>
            Explore
          </NavLink>
        </Router>

        <HeaderControls>
          <HeaderElement>
            <TestnetWrapper>
              {/* {!isMobile && chainId && NETWORK_LABELS[chainId] && <NetworkCard>{NETWORK_LABELS[chainId]}</NetworkCard>} */}
            </TestnetWrapper>
            <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
              {/* {account && userEthBalance ? (
                <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                  {userEthBalance?.toSignificant(4)} ETH
                </BalanceText>
              ) : null} */}

              {!isMobile && <Tips />}

              <Web3Status />
            </AccountElement>
          </HeaderElement>
          <HeaderElementWrap>
            {
              // <VersionSwitch />
            }
            <Settings />
            {/* <Menu /> */}
          </HeaderElementWrap>
        </HeaderControls>
      </RowBetween>
    </HeaderFrame>
  )
}
